import React, { useEffect, useState, useContext } from "react";
import { CurrentUserContext } from "../../../context/CurrentUserContext";
import { Link, useParams } from "react-router-dom";
import { slugToText } from "../../../utils/slugify";
import "./FundamentalsMyNotes.css";
import DeleteNotePopup from "../../PopupWithForm/DeleteNotePopup";
import { useTranslation } from "../../../utils/hooks/translateHook";
import downloadIcon from "../../../images/icons/download.svg";
import viewIcon from "../../../images/icons/viewIcon.svg";
import deleteIcon from "../../../images/icons/DeleteIcon.svg";
import nots from "../../../images/Notes_1440.png";
import videoArrow from "../../../images/icons/videoArrow.svg"

export const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:4000/api"
    : process.env.REACT_APP_API_URL;

const FundamentalsMyNotes = () => {
  const { currentUser, notesUpdated, setNotesUpdated } =
    useContext(CurrentUserContext);
  const { courseSlug } = useParams();
  const [notes, setNotes] = useState([]);
  const [selectedNote, setSelectedNote] = useState(null);
  const [noteToDelete, setNoteToDelete] = useState(null);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const t = useTranslation();

 const groupedNotes = notes.reduce((acc, note) => {
  const noteSlug = note.videoSlug || "";
  const isEbookNote = noteSlug.includes("--chapter-");

  // כל הפתקים מהווידאו נכנסים לקבוצה קבועה אחת
  if (!isEbookNote) {
    const groupKey = "videos";

    if (!acc[groupKey]) {
      acc[groupKey] = {
        type: "video",
        title: "Videos",
        notes: [],
      };
    }

    acc[groupKey].notes.push({
      ...note,
      type: "video",
    });

    return acc;
  }

  // פתקים של Ebook מתחלקים לפי ה-PDF
  const [pdfSlug, chapterPage] = noteSlug.split("--chapter-");
  const groupKey = `ebook-${pdfSlug}`;

  if (!acc[groupKey]) {
    acc[groupKey] = {
      type: "ebook",
      title: slugToText(pdfSlug),
      pdfSlug,
      notes: [],
    };
  }

  acc[groupKey].notes.push({
    ...note,
    type: "ebook",
    pdfSlug,
    chapterPage: Number(chapterPage),
  });

  return acc;
}, {});
const getNoteLink = (note) => {
  if (note.type === "ebook") {
    return `/course/${courseSlug}/docs/${note.pdfSlug}?page=${note.chapterPage}`;
  }

  return `/course/${courseSlug}/videos/${note.videoSlug}`;
};
const getNoteTitle = (note) => {
  if (note.type === "ebook") {
    return `Chapter page ${note.chapterPage + 1}`;
  }

  return slugToText(note.videoSlug).replace(
    /^(\d+)\s(\d+)\s(\d+)/,
    "$1.$2.$3"
  );
};

  const fetchNotes = () => {
    fetch(`${API_URL}/notes/course/${courseSlug}?_=${Date.now()}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}`,},
    })
      .then((res) => res.json())
      .then((data) => {
        const sorted = data.sort((a, b) => {
          const parse = (slug) => {
            if (!slug) return [0, 0, 0];
            const nums = slug.split("-").map((n) => Number(n));
            return nums.length >= 3 ? nums.slice(0, 3) : [0, 0, 0];
          };
          const [a1, a2, a3] = parse(a.videoSlug);
          const [b1, b2, b3] = parse(b.videoSlug);
          return a1 - b1 || a2 - b2 || a3 - b3;
        });
        setNotes(sorted);
      });
  };

  useEffect(() => {
    if (!currentUser?._id) return;
    fetchNotes();
  }, [currentUser, notesUpdated, courseSlug]);


  const handleDeleteNote = (note) => {
    fetch(`${API_URL}/notes/${courseSlug}/${note.videoSlug}?_=${Date.now()}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}`,},
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to delete");
        fetchNotes();
        setNotesUpdated((prev) => prev + 1);
        setIsDeletePopupOpen(false);
      })
      .catch((err) => {
        alert("Error deleting note");
        console.error(err);
      });
  };

  const downloadNote = (slug, content) => {
    const element = document.createElement("a");
    const file = new Blob([content], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = `${slugToText(slug)}.txt`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="frameN fundamentals-theme">
      <h3 className="notes-title-fun">
        <span>{t("notes")}</span>
        <img src={videoArrow} alt="" className="notes-arrow"/>
      </h3>

      <div className="lay">
        <div className="notes-layout">
          <div className="notes-list">
            {notes.length === 0 && <p>{t("noNotes")}</p>}
            <div className="notes-group">
              {Object.entries(groupedNotes).map(([groupKey, group]) => (
                <div key={groupKey} className="notes-group">
                  <div className="notes-group-title"> {group.title}</div>
                  <ul>
                    {group.notes.map((note) => (
                      <li key={note._id} className="note-item-html">
                        <div className="note-header">
                          <Link  className="note-title"
                            to={getNoteLink(note)}                    
                          >
                            {getNoteTitle(note)}
                          </Link>
                          <div className="note-actions">
                            <button className="icon-button-nots"
                              onClick={() => downloadNote(note.videoSlug, note.content)}
                              title="Download"
                            >
                              <div className="icon" style={{ "--icon": `url(${downloadIcon})`}}></div>
                            </button>
                            <button className="icon-button-nots"
                              onClick={() => setSelectedNote(selectedNote?._id === note._id ? null : note)}
                              title="View"
                            >
                              <div className="icon" style={{ "--icon": `url(${viewIcon})` }}/>
                            </button>
                            <button className="icon-button-nots"
                              onClick={() => {
                                setNoteToDelete(note);
                                setIsDeletePopupOpen(true);
                              }}
                              title="Delete"
                            >
                              <div className="icon" style={{ "--icon": `url(${deleteIcon})` }}/>
                            </button>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="notes-preview">
            {!selectedNote ? (
              <img src={nots} className="notes-image" alt="preview" />
            ) : (
              <div className="note-content">
                {selectedNote.content}
              </div>
            )}
          </div>
        </div>
      </div>

      <DeleteNotePopup
        isOpen={isDeletePopupOpen}
        onClose={() => setIsDeletePopupOpen(false)}
        onDelete={handleDeleteNote}
        note={noteToDelete}
      />
    </div>
  );
};

export default FundamentalsMyNotes;